export default "__VITE_ASSET__ypQH9Xja__"